<template aria-labelledby="next-steps-heading">

    <div class="mt-12">
        <v-row class="ma-2" align="center" justify="center">
            <div class="next">
              <h2 id="next-steps-heading">{{ $t('next-steps.next-steps') }}</h2>
            </div>
        </v-row>
        <v-row align="center" justify="center">
            <button :class="step1" @click="moveCarousel(0)"
              aria-controls="carousel-items"
              :aria-label="$t('Accessibility.step_one')"
            >1</button>
            <hr class="ms-1 me-1" style="color:#bbbbbb; width: 6em; border: 0.1em solid" aria-hidden="true"/>
            <button :class="step2" @click="moveCarousel(2)"
               aria-controls="carousel-items"
               :aria-label="$t('Accessibility.step_two')"
            >2</button>
            <hr class="ms-1 me-1" style="color:#bbbbbb; width: 6em; border: 0.1em solid" aria-hidden="true"/>
            <button :class="step3" @click="moveCarousel(5)"
               aria-controls="carousel-items"
               :aria-label="$t('Accessibility.step_three')"
            >3</button>
        </v-row>

    </div>
    <v-row align="center" class="mt-8">

        <v-col cols="6" sm="2" class="d-sm-flex flex-row-reverse">
            <div>
              <v-btn
                  @click="moveCarousel((((modelIndex - 1) % 6) + 6) % 6)"
                  elevation="0"
                  variant="plain"
                  class="control-carousel-btn"
                  :ripple="false"
                  :aria-label="$t('Accessibility.previous_slide')"
                  aria-controls="carousel-items"
              >
                <v-img class="pointer" align="right" src="/assets/left.png" width="4em" max-width="4em" aria-hidden="true" />
              </v-btn>
            </div>
        </v-col>

        <v-col cols="12" sm="8" order="3" order-sm="2">

            <v-card width="100%" max-width="70vw" height="auto" min-height="15em" rounded="xl" justify="center" align="center"
                    :aria-label="$t('Accessibility.carousel')"
            >

                <v-card-text class="ma-4">

                    <v-carousel :keyboard="true" height="auto" min-height="15em"  align="center" hide-delimiters :show-arrows="false" v-model="modelIndex" @update:model-value="updateCarousel"
                      id="carousel-items"
                      aria-live="polite"
                    >

                        <v-carousel-item v-for="step in steps" v-bind:key="step.image"
                                         role="group"
                                         aria-roledescription="slide">
                            <v-row>
                                <v-col justify="start" align="start">
                                    <v-img :src="step.icon" width="2em" height="2em" alt="" /><br />
                                    <p v-html="$t(step.text)" />
                                </v-col>
                                <v-col cols="5" class="d-none d-sm-flex">
                                    <v-img :src="step.image" height="15em" alt="" />
                                </v-col>
                            </v-row>
                            <v-row class="d-flex d-sm-none">
                                <v-col>
                                    <v-img :src="step.image" height="15em" alt="" />
                                </v-col>
                            </v-row>
                        </v-carousel-item>
                        
                    </v-carousel>

                </v-card-text>

            </v-card>
        </v-col>

      <v-col cols="6" sm="2" order="2" order-sm="3" class="d-sm-flex">
          <v-btn
              @click="moveCarousel((modelIndex + 1) % 6)"
              elevation="0"
              variant="plain"
              class="control-carousel-btn"
              :ripple="false"
              :aria-label="$t('Accessibility.next_slide')"
              aria-controls="carousel-items"
          >
            <v-img class="pointer" src="/assets/right.png" width="4em" max-width="4em" aria-hidden="true" />
          </v-btn>
        </v-col>

    </v-row>

</template>

<script>
export default {


    data() {
      return {
        modelIndex: 0,
        step1: "circle-selected",
        step2: "circle",
        step3: "circle",
        steps: [
            {
                image: "/assets/next-steps/1.png",
                icon: "/assets/cog.svg",
                text: "next-steps.step11"
            },
            {
                image: "/assets/next-steps/2.png",
                icon: "/assets/cog.svg",
                text: "next-steps.step12"
            },
            {
                image: "/assets/next-steps/3.png",
                icon: "/assets/mic.svg",
                text: "next-steps.step21"
            },
            {
                image: "/assets/next-steps/4.png",
                icon: "/assets/cam.svg",
                text: "next-steps.step22"
            },
            {
                image: "/assets/next-steps/5.png",
                icon: "/assets/cog_account.svg",
                text: "next-steps.step23"
            },
            {
                image: "/assets/next-steps/6.png",
                icon: "/assets/like.svg",
                text: "next-steps.step31"
            },
        ]
      }
    },
    methods: {
        updateCarousel(index) {
            if (index<2) {
                this.step1="circle-selected";
                this.step2="circle";
                this.step3="circle";
            } else if (index<5) {
                this.step1="circle";
                this.step2="circle-selected";
                this.step3="circle";
            } else {
                this.step1="circle";
                this.step2="circle";
                this.step3="circle-selected";
            }
        },
        moveCarousel(index) {
            this.modelIndex = index;
            this.updateCarousel(index);
        }
    }

}
</script>

<style scoped>

.next {

    font-family: 'Nunito Sans ExtraBold';
    font-size: 1.65em;

}

h2 {
  font-size: 1em;
}

.v-btn {
  opacity: 100;
}

.v-btn:focus-visible::after {
  opacity: unset !important;
}
</style>